import { render, staticRenderFns } from "./Users_account.vue?vue&type=template&id=32afbee4&scoped=true&lang=pug&"
import script from "./Users_account.vue?vue&type=script&lang=coffee&"
export * from "./Users_account.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32afbee4",
  null
  
)

export default component.exports